<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>能耗分析</el-breadcrumb-item>
			<el-breadcrumb-item>纵向对比分析</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search" @submit.native.prevent>
			<el-form-item label="统计对象：">
				<el-popover v-model="visible">
					<el-input ref="deptInput" class="cp" readonly slot="reference" autosize size="small"  placeholder="选择部门/集中器"
					 v-model="getJZ"></el-input>
					<div >
						<el-tree v-loading="treeLoad" :data="treeDate" :expand-on-click-node="false" :highlight-current="true" ref="tree"
						 @node-click="handleNodeClick" :props="jzProps" accordion node-key='id' show-checkbox @check="checkTerIds">
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>
									<i v-if="!data.parentId && !data.isJz" class="el-icon-office-building"></i>
									<i v-if="data.parentId" class="el-icon-location-outline"></i>
									<i v-if="data.isJz" class="el-icon-coin"></i>
									{{ data.departmentName }}
								</span>
							</span>
						</el-tree>
					</div>
				</el-popover>
			</el-form-item>

      <el-form-item label="能源种类">
        <el-select size="small" v-model="formInline.energyType" style="width: 140px;" placeholder="请选择" @change="getData">
          <el-option label="全部" value="">
          </el-option>
          <el-option
            v-for="item in energyType"
            :key="item.id"
            :label="item.value"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.dateType"  style="width: 120px;"  @change="getDateType" >
          <el-option
            v-for="item in dateList"
            :key="item.value"
            :label="item.lable"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
         <el-date-picker
            @change="getData"
            style="width: 120px;"
            v-if="formInline.dateType == 'day'"
            size="small"
            value-format="yyyy-MM"
            v-model="formInline.monthDate"
            type="month"
            placeholder="选择月">
         </el-date-picker>
         <el-date-picker
            style="width: 120px;"
             @change="getData"
            v-if="formInline.dateType == 'month'"
            size="small"
            value-format="yyyy"
            v-model="formInline.yearDate"
            type="year"
            placeholder="选择年">
         </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button :disabled="nRefresh" type="primary" size="small" @click="Refresh">刷新</el-button>
      </el-form-item>
		</el-form>

		<!--列表-->
		<div class="paybox">
		  <div class="cavasbox" ref="fengLei"></div>
		</div>

    <el-table size="small" :data="dataList"  highlight-current-row  :header-cell-style="this.$store.state.headerCss" v-loading="loading"   border element-loading-text="拼命加载中">
      <el-table-column  label="能源种类" prop="name" width="240" fixed>
      </el-table-column>
      <el-table-column :label="t_title" >
        <el-table-column align="center" :label="item.value"  :prop="item.port" v-for="item in dataCol" min-width="120"></el-table-column>
      </el-table-column>

    </el-table>

	</div>
</template>

<script>
  import Chart from 'echarts'
	import { findPortraitList } from '../../api/analysisMG'
  import {getDepartmentTerminalInfoLis,getTerminalInfoByDepId} from '../../api/energyMG'
	export default {
		data(){
			return{
				leftDataList:[],
        leftDataCol:[],
        dataList:[],
        dataCol:[],
        nRefresh:false,
				formInline:{
					dateType:'day',
				  monthDate:new Date().getFullYear() + '-' +( new Date().getMonth()+1 < 10 ? '0':'' ) + (new Date().getMonth()+1),
					yearDate:"",
					terIds:"",
          energyType:'',

				},
        depId:'',
        tableHeight: 0,
        dateList:[
          { value:'day',lable:'逐日' },
          { value:'month',lable:'逐月' },
        ],
        typeList:[
          { value:15,label:'电'},
          { value:16,label:"水"}
        ],
        t2ids:[],
        t_title: new Date().getFullYear() + '-' +( new Date().getMonth()+1 < 10 ? '0':'' ) + (new Date().getMonth()+1),
        getJZ:"",
        visible:false,
        loading:false,
        tableLabel:[],
        treeLoad:false,
        treeDate:[],
        dbData:[],
        energyType:[],
        jzProps: {
        	label: "departmentName",
        	children: 'deps'
        },
        user:{}

			}
		},
		created(){


      this.getJzData().then( res => {
        console.log(res)
        this.formInline.terIds = this.getTepIds(res[0].id)
        this.getJZ = res[0].departmentName

        this.getData()
      });
      this.$store.dispatch('getEnergyTypeConfig').then( (res) => {

      	this.energyType = res

      })
		},
    mounted() {
    	this.$nextTick(() => {this.tableHeight = window.innerHeight - 175-30})
    },
		methods:{
			search(){

			},

      //获取比较对象的ids
      getBjIds(){

      },

      getDateType(e){
       if(e == 'day'){
         let dateStr = new Date().getFullYear() + '-' +( new Date().getMonth()+1 < 10 ? '0':'' ) + (new Date().getMonth()+1)
          this.t_title = dateStr
         this.formInline.dateType = 'day'
         this.formInline.monthDate = dateStr
         this.formInline.yearDate = ''
       }else if( e == 'month'){

          this.formInline.dateType = 'month'
          this.formInline.monthDate = ''
          this.formInline.yearDate = new Date().getFullYear()+''
          this.t_title = new Date().getFullYear()+''
       }

        this.getData()

      },
      Refresh(){
        this.getData()

      },
			getData(){
        this.loading = true
        this.t_title = this.formInline.monthDate || this.formInline.yearDate
				findPortraitList(this.formInline).then(res => {
          this.loading = false
					if(res.status == 1){
           let stemp = []
           let dtemp = []
           let legendame= []


           if(res.data.data.echartsData){
             res.data.data.echartsData.forEach(item => {
               legendame.push(item.name)
               let s = {
                 	name: item.name,
                 	type: 'bar',
                 	data: item.data,
               }
               stemp.push(s)
             })
           }
           if(res.data.data.dataList){
            res.data.data.dataList.forEach(item => {
              dtemp.push(item)
            })
           }


           this.dataList = dtemp
           this.dataCol = res.data.headerArr

           console.log(this.dataList)

           let option = {
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: legendame,
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              show: true,
              feature: {
                mark: {
                  show: true
                },
                dataView: {
                  show: true,
                  readOnly: false
                },
                magicType: {
                  show: true,
                  type: ['line', 'bar'],
                },
                restore: {
                  show: true
                },
                saveAsImage: {
                  show: true
                }
              }
            },
            calculable: true,
            xAxis: [{
              type: 'category',
              data: res.data.echart
            }],
            yAxis: [{
              type: 'value',
            }],
            series: stemp
           }
            this.chart = Chart.init(this.$refs.fengLei)
            this.chart.setOption(option,true)
          }
				})
			},


      //获取集中器信息
      getJzData: function() {
      	return new Promise((resolve, reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if (res.status == 1) {
      				this.treeDate = this.changeData(res.data.menuDepList)
              resolve(this.treeDate)
      			} else {
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },
      changeData(data) {
      	data.forEach(item => {
      		if (item.terminalInfo) {
      			if (!item.deps) {
      				item.deps = []
      			}
      			item.terminalInfo.forEach(sitem => {
      				let obj = {}
      				obj.id = sitem.id
              obj.pid = item.id
              obj.pname = item.departmentName
      				obj.departmentName = sitem.terminalName
      				obj.terminalCode = sitem.terminalCode
      				obj.isJz = true
      				item.deps.push(obj)
      			})
      		}
      		if (item.deps) {
      			this.changeData(item.deps)
      		}
      	})
      	return data
      },

      checkTerIds(data, checked){
        //选择部门
        if(!data.isJz){

          console.log(this.$refs.tree.getNode(data.id).checked)
          if( this.depId != data.id ){
            this.$refs.tree.setCheckedKeys([]);
            this.$refs.tree.setCheckedKeys([data.id]);
          }

          this.depId = data.id
          this.getJZ = data.departmentName
          this.formInline.terIds = this.getTepIds(data.id)


        }else{  //选择集中器
          if( data.pid != this.depId ){
            this.$refs.tree.setCheckedKeys([data.id]);
          }
          this.depId = data.pid
          this.getJZ = data.pname
          let ids = []
          this.$refs.tree.getCheckedNodes().forEach(item => {
            if(item.isJz){
              ids.push(item.id)
            }
          })
          this.formInline.terIds = ids.join(',')
          this.getTepIds(data.pid)

        }
        this.t2ids = []
      },

      // getTerIdsOnLine(id){
      //   getTerminalInfoByDepId({
      //   	depId: id
      //   }).then(res => {
      //   	if (res.status == 1) {
      //       console.log(res)
      //   	} else {
      //   		this.$message.error(res.msg)
      //   	}
      //   })
      // },

      getTepIds(id){
        // 点击部门获得集中器id
        let tmep = []
        this.treeDate.forEach(item => {
          if(item.id == id){
            this.dbData = item.deps
            tmep = item.deps
          }
        })
        return tmep.map(item => item.id).join(',')

      },
      handleNodeClick(data) {



      },

      rowClass(){
        return "color:#5c5c5c;background:#fff"
      },



		}
	}



</script>

<style>
  .el-tree-node.is-expanded>.el-tree-node__children{
     max-height: 360px;
     overflow: auto;
   }
   .paybox {
   	width: 100%;
   	background-color: #fff;
   	box-sizing: border-box;
   	border-radius: 5px;
     overflow: hidden;
   	height: 340px;
    margin-bottom: 30px;
   }
   .cavasbox {
   	box-sizing: border-box;
   	width: 100%;
   	height: 100%;
   }
</style>



// WEBPACK FOOTER //
// src/views/analysis/verticalData.vue